import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator"; //@ts-check

import formulas from '../../formulas';
import apiClient from '../../binding/apiClient';
import ACTIONS from '../actions';
import cloneDeep from 'lodash/cloneDeep';
import fieldsValuesCalculator from './fieldsValuesCalculator';
import repeatingLogic from '../repeatingLogic';
/**
 * @param {import("../types").EcrionFormState} state
 * @param {any} dispatch
 */

var resolveFormDataBinding = function resolveFormDataBinding(state, dispatch) {
  var cloneState = cloneDeep(state);
  calculateContextDependentFields(cloneState);
  calculateContextDependentFieldsProperties(cloneState, ['defaultValue']);
  performInitialBindings(cloneState).then(function () {
    calculateDependentFields(cloneState);
    calculateDependentProperties(cloneState, ['defaultValue']);
    repeatingLogic.generateInitialRepeating(cloneState);
    var fields = {};
    var changes = {};
    var updates = [];
    Object.keys(cloneState.data).forEach(function (fieldId) {
      if (cloneState.data[fieldId] !== state.data[fieldId]) changes[fieldId] = cloneState.data[fieldId];
    });
    Object.keys(cloneState.fields).forEach(function (fieldId) {
      var field = state.fields[fieldId];
      var clonedField = cloneState.fields[fieldId]; // collect added fields to be migrated to the original state

      if (clonedField && !field) fields[clonedField.id] = clonedField;
      if (!field || !clonedField) return;
      if (field.type === 'dropdown' && clonedField.type === 'dropdown' && field.options.length === 0 && clonedField.options.length !== 0) updates.push({
        id: fieldId,
        updateProperties: {
          options: clonedField.options
        }
      });
      if (field.type === 'form' && clonedField.type === 'form' && field.submitTmpl !== clonedField.submitTmpl) updates.push({
        id: fieldId,
        updateProperties: {
          submitTmpl: clonedField.submitTmpl
        }
      });
      if (field.type === 'repeating' && clonedField.type === 'repeating' && clonedField.childrenMap) updates.push({
        id: fieldId,
        updateProperties: {
          childrenMap: clonedField.childrenMap
        }
      });
    });
    dispatch({
      type: ACTIONS.SET_FIELDS_META,
      payload: cloneState.meta
    });
    dispatch({
      type: ACTIONS.ADD_FIELDS,
      payload: fields
    });
    dispatch({
      type: ACTIONS.SET_FIELDS_PROPERTIES,
      payload: updates
    });
    dispatch({
      type: ACTIONS.SET_FIELDS_VALUES,
      payload: changes
    });
    dispatch({
      type: 'DATA_BINDING_RESOLVED'
    });
  });
};
/**
 * @param {import('../../binding/types').Binding} left
 * @param {import('../../binding/types').Binding} right
 * @returns {number}
 */


var compareBindingOrder = function compareBindingOrder(left, right) {
  if (left.dataSource === right.dataSource) {
    if (right.xpath.startsWith(left.xpath)) return -1;
    return 1;
  }

  return 0;
};
/**
 *
 * @param {import('../types').EcrionFormState} state
 * @returns {Array<import('../../binding/types').Binding>}
 */


var getInitialBindings = function getInitialBindings(state) {
  var formBindings = state.formBindings;
  /** @type {Array<import('../../binding/types').Binding>} */

  var initialBindings = [];
  Object.keys(formBindings.bindings).forEach(function (bindingId) {
    var binding = formBindings.bindings[bindingId];
    initialBindings.push(binding);
  });
  return initialBindings.sort(function (left, right) {
    return compareBindingOrder(left, right);
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @returns {Promise}
 */


var performInitialBindings =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(state) {
    var bindings, initialBindings, result, idx, binding, bindingFields;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bindings = state.formBindings;

            if (bindings) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 3:
            if (state.renderOptions.enableAutomaticLookupOnLoad) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 5:
            initialBindings = getInitialBindings(state);
            result = [];
            _context.prev = 7;
            idx = 0;

          case 9:
            if (!(idx < initialBindings.length)) {
              _context.next = 20;
              break;
            }

            binding = initialBindings[idx];
            bindingFields = binding.fields;
            _context.next = 14;
            return performInitialBinding(state, binding);

          case 14:
            if (!bindingFields.find(function (f) {
              return state.fields[f.fieldId].type === 'dropdown' && state.fields[f.fieldId].options.length === 0;
            })) {
              _context.next = 17;
              break;
            }

            _context.next = 17;
            return performValuesBinding(state, binding);

          case 17:
            idx++;
            _context.next = 9;
            break;

          case 20:
            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](7);
            return _context.abrupt("return", result);

          case 25:
            return _context.abrupt("return", result);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 22]]);
  }));

  return function performInitialBindings(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @param {import("../types").EcrionFormState} state
 * @param {import('../../binding/types').Binding} binding
 */


var performInitialBinding = function performInitialBinding(state, binding) {
  var dataSource = binding.dataSource,
      xpath = binding.xpath,
      fields = binding.fields;
  var parameters = getLookupParameters(state);
  var filter = getLookupFilter(state, binding);
  var workspace = state.options.workspace;
  return new Promise(function (resolve) {
    apiClient.lookup(workspace, dataSource, xpath, fields.map(function (f) {
      return f.source;
    }), parameters, filter).then(function (lookupResult) {
      var columnNames = lookupResult.columnNames,
          rows = lookupResult.rows;
      if (!rows || rows.length !== 1) return;
      var row = rows[0]; // update last selected context

      binding.context = row.Context;
      fields.forEach(function (f) {
        var idx = columnNames.indexOf(f.source);
        state.data[f.fieldId] = row.values[idx];
      });
    }).finally(function () {
      resolve();
    });
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {import('../../binding/types').Binding} binding
 */


var performValuesBinding = function performValuesBinding(state, binding) {
  var dataSource = binding.dataSource,
      xpath = binding.xpath,
      fields = binding.fields;
  var parameters = getLookupParameters(state);
  var workspace = state.options.workspace;
  return new Promise(function (resolve) {
    apiClient.lookup(workspace, dataSource, xpath, fields.map(function (f) {
      return f.source;
    }), parameters, {
      jobId: state.options.jobId || ''
    }).then(function (lookupResult) {
      if (!lookupResult.rows || lookupResult.rows.length === 1) return;
      var columnNames = lookupResult.columnNames,
          rows = lookupResult.rows;
      fields.forEach(function (f) {
        var formField = state.fields[f.fieldId];
        var idx = columnNames.indexOf(f.source);
        if (formField.type === 'dropdown' && formField.options.length === 0) formField.options = rows.map(function (r) {
          return {
            label: r.values[idx],
            value: r.values[idx]
          };
        });
      });
    }).finally(function () {
      resolve();
    });
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @returns {Array<{Name:string, Value:string}>}
 */


var getLookupParameters = function getLookupParameters(state) {
  var environmentVars = state.context.environmentVars;
  var parameters = []; // add contact id param by default

  var contactId = environmentVars && environmentVars['ContactId'];
  if (contactId) parameters.push({
    Name: 'ContactId',
    Value: contactId
  });
  return parameters;
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {import('../../binding/types').Binding} binding
 * @returns {import('../../binding/types').LookupFilter}
 */


var getLookupFilter = function getLookupFilter(state, binding) {
  var dataSourcePath = binding.dataSource,
      bindingXPath = binding.xpath,
      fields = binding.fields;
  var filter = {
    filterFieldName: '',
    filterValue: '',
    matchExact: true,
    context: '',
    jobId: state.options.jobId || ''
  };
  var formFields = fields.map(function (f) {
    return state.fields[f.fieldId];
  });
  formFields.forEach(function (field, idx) {
    if (filter.filterFieldName) return; // filter already detected (for now, only one filter is supported)

    if (!field.defaultValue) return; // we use as filter for initial binding only fields with default value

    if (!state.data[field.id]) return; // we are only interested about fields with default value calculated

    filter.filterFieldName = fields[idx].source;
    filter.filterValue = state.data[field.id] + '';
  }); // inherit context from parent

  Object.keys(state.formBindings.bindings).forEach(function (bindingId) {
    var _state$formBindings$b = state.formBindings.bindings[bindingId],
        dataSource = _state$formBindings$b.dataSource,
        xpath = _state$formBindings$b.xpath;
    if (dataSource !== dataSourcePath) return;
    if (xpath.length < bindingXPath.length && bindingXPath.startsWith(xpath)) filter.context = binding[xpath].context;
  });
  return filter;
};
/**
 * @param {import("../types").EcrionFormState} state
 */


var calculateContextDependentFields = function calculateContextDependentFields(state) {
  // for all fields without value, perform calculation based on context
  var fields = searchBindableFields(state);
  var contextDependentsFields = fields.filter(function (field) {
    return dependsOnContext(field.defaultValue, state);
  });
  contextDependentsFields.forEach(function (field) {
    var newValue = formulas.calculate(field.defaultValue, field, state);

    if (newValue) {
      state.data[field.id] = newValue;
    }
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {Array<string>} excludedProperties
 */


var calculateContextDependentFieldsProperties = function calculateContextDependentFieldsProperties(state) {
  var excludedProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  Object.keys(state.fields).forEach(function (fieldId) {
    var field = state.fields[fieldId];
    Object.keys(field).forEach(function (propName) {
      if (excludedProperties.includes(propName)) return;
      var propValue = field[propName];
      if (!dependsOnContext(propValue + '', state)) return;
      fieldsValuesCalculator.updateFieldProperty(state, fieldId, propName, propValue + '');
    });
  });
};
/**
 * @param {import("../types").EcrionFormState} cloneState
 */


var calculateDependentFields = function calculateDependentFields(cloneState) {
  // for all fields without value, perform calculation based on other fields
  var fields = searchBindableFields(cloneState);
  var fieldDependentsFields = fields.filter(function (field) {
    return dependsOnFields(field, cloneState);
  });
  fieldDependentsFields.forEach(function (field) {
    var newValue = formulas.calculate(field.defaultValue, field, cloneState);

    if (newValue) {
      cloneState.data[field.id] = newValue;
    }
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {Array<string>} excludedProperties
 */


var calculateDependentProperties = function calculateDependentProperties(state, excludedProperties) {
  Object.keys(state.fields).forEach(function (fieldId) {
    var field = state.fields[fieldId];
    Object.keys(field).forEach(function (propName) {
      if (excludedProperties.includes(propName)) return;
      var propValue = field[propName];
      fieldsValuesCalculator.updateFieldProperty(state, fieldId, propName, propValue + '');
    });
  });
};
/**
 * Search for fields containing 'defaultValue' property but no data loaded
 * @param {import("../types").EcrionFormState} state
 * @return {Array<import("../types").EcrionFormField>}
 */


var searchBindableFields = function searchBindableFields(state) {
  var fieldsWithDefault = searchFieldsWithDefaultValue(state);
  return fieldsWithDefault.filter(function (field) {
    return field && !state.data[field.id];
  });
};
/**
 * @param {import("../types").EcrionFormState} state
 * @return {Array<import("../types").EcrionFormField>}
 */


var searchFieldsWithDefaultValue = function searchFieldsWithDefaultValue(state) {
  return searchFieldsWithProp(state, 'defaultValue');
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {string} propName
 * @return {Array<import("../types").EcrionFormField>}
 */


var searchFieldsWithProp = function searchFieldsWithProp(state, propName) {
  if (!state || !state.fields) return [];
  var fields = Object.keys(state.fields).map(function (fieldId) {
    return state.fields[fieldId];
  });
  return fields.filter(function (field) {
    return field && field[propName];
  });
};
/**
 * Check if a field contains a defaultValue that depends only on context
 * @param {string} value
 * @param {import('../types').EcrionFormState} state
 * @returns {boolean}
 */


var dependsOnContext = function dependsOnContext(value, state) {
  var dependencies = formulas.parseDependencies(value, state);
  if (!dependencies || !dependencies.length) return false;
  return !dependencies.find(function (dependency) {
    return dependency.type !== 'context';
  });
};
/**
 * Check if a field contains a defaultValue that depdends on other fields
 * @param {import('../types').EcrionFormField} field
 * @param {import('../types').EcrionFormState} state
 */


var dependsOnFields = function dependsOnFields(field, state) {
  var dependencies = formulas.parseDependencies(field.defaultValue, state);
  if (!dependencies || !dependencies.length) return false;
  return dependencies.find(function (dependency) {
    return dependency.type === 'field';
  });
};

export default resolveFormDataBinding;